import React from "react";
import { footer } from "../data/content";
export function Footer() {
  return <footer className="bg-navy-dots px-5 pb-28 pt-2 sm:px-10 md:pb-8" data-id="element-67" data-mp="3gf94uw0pu68y">
      <p className="border-t border-white/15 pt-6 text-center text-xs leading-relaxed text-white/60" data-id="element-68" data-mp="3ggka709t7m26">
        {footer.text}
      </p>
    </footer>;
}